<script>
  export default{
    name: 'i-alterar-timer',
    data () {
      return {
        valor: ''
      }
    },
    computed: {
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      focusMe () {
        this.$refs.input.focus()
      },
      alterar () {
        if (this.valor === 0) {
          return
        }
        this.$emit('alterarTimer', this.valor)
        this.reset()
      },
      reset () {
        this.valorFormatado = ''
      }
    },
    components: {}
  }
</script>

<template>
  <div class="lance-input-container">
    <label>Alterar tempo:</label>
    <div class="pos-rlt">
      <input ref="input" v-shortkey="['f9']" @shortkey="focusMe" type="number" v-model="valor" class="lance-input no-shortkey" placeholder="10" @keyup.enter="alterar"/>
      <i class="shoutcut">F9</i>
    </div>
    <u-button class="lance-btn" @click="alterar">OK</u-button>
  </div>
</template>



// WEBPACK FOOTER //
// InputAlterarTimer.vue?32de0a2f